import * as request from '@/utils/request'
const BASE_URL = '/v1/manage/salary/openapi/config'
export default {
	/**
	 * @description 查看列表
	 * @author Lzp
	 * @date 2021/9/29
	 * @param {*} data
	 * @returns
	 */
	getPayManageList(data) {
		return request.get(`${BASE_URL}/list`, data)
	},
    
    getBusmodListList(data) {
		return request.post(`${BASE_URL}/businessType`, data)
	},

	updatePayManageInfo(id, data) {
		return request.put(`${BASE_URL}/update/${id}`, data)
	},

	postPayManageInfo(data) {
		return request.post(`${BASE_URL}/store`,data)
	},
    
    getPayMangeChannelList(data) {
        return request.get(`/v1/manage/salary/openapi/settlement`, data)
    },
    
    getXWPayMangeChannelList(data) {
        return request.get(`/v1/hr/salary/openapi/config/settlement/channel`, data)
    },
    
    deleteOpenApiConfig(id,data){
        return request.Delete(`/v1/manage/salary/openapi/config/${id}`, data)
    },
    
    getPayWithoutCardCompanyList(data) {
        return request.get(`/v1/manage/company`, data)
    },
    
    switchWalletStatus(id,data){
        return request.put(`/v1/manage/company/update/${id}`, data)
    },
}
